<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <div
        :class="$style.sectionRoot"
      >
        <GettingStartedPanel
          buttonLabel="Configure MDM"
          :itemType="itemType"
          :visible="shouldRenderGettingStarted && !showLoadingOverlay"
          @ctaButtonClick="handleGettingStartedCta()"
        />
        <LoadingOverlay
          :showLoadingOverlay="showLoadingOverlay"
        />

        <div v-if="!shouldRenderGettingStarted && !showLoadingOverlay">
          <div>
            <header>
              <h4 :class="[$style.sectionHeader, $style.title]">
                User iOS Configuration
              </h4>
              <IconTooltip
                :iconClass="['jc-info-circle', $style.tooltipIcon]"
              >
                <p>{{ userConfiguration.tooltipText }}</p>
                <IconTooltipReadMore
                  :kbLink="userConfiguration.kbLink"
                />
              </IconTooltip>
            </header>
            <MdmIOSUserEnrollment />
          </div>

          <div
            :class="$style.configContainer"
          >
            <header>
              <h4 :class="[$style.sectionHeader, $style.title]">
                Admin iOS Configuration
              </h4>
              <IconTooltip
                :iconClass="['jc-info-circle', $style.tooltipIcon]"
              >
                <p>{{ adminConfiguration.tooltipText }}</p>
                <IconTooltipReadMore
                  :kbLink="adminConfiguration.kbLink"
                />
              </IconTooltip>
            </header>
            <MdmAdminIOSConfiguration />
          </div>
        </div>
      </div>
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { ItemTypeConsts, ItemTypeRoutes, StoreModelMap } from 'client/util/Constants';
import { isEmpty } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import GettingStartedPanel from 'client/components/GettingStartedPanel/GettingStartedPanel.vue';
import IconTooltip from 'client/components/Tooltip/IconTooltip.vue';
import IconTooltipReadMore from 'client/components/Tooltip/IconTooltipReadMore.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import LoadingOverlay from 'client/components/LoadingOverlay/LoadingOverlay.vue';
import MdmAdminIOSConfiguration from 'client/MDM/MdmAdminIOSConfiguration.vue';
import MdmIOSUserEnrollment from 'client/MDM/MdmIOSUserEnrollment.vue';
import TooltipTextConstants from 'client/util/Constants/ToolTipTextConstants';
import Util from 'client/util/Util';

const mdmSettingsModel = StoreModelMap[ItemTypeConsts.mdmSettings];

export default {
  name: 'CreateIOSDevice',

  components: {
    IconTooltip,
    IconTooltipReadMore,
    LoadingOverlay,
    MdmAdminIOSConfiguration,
    MdmIOSUserEnrollment,
    GettingStartedPanel,
    DetailsAsideLayout,
  },

  data() {
    return {
      adminConfiguration: {
        tooltipText: TooltipTextConstants.mdmIOSAdminEnrollment,
        kbLink: KbArticleUrls.enrolllingIosDevicesInMdm,
      },
      itemType: ItemTypeConsts.mdmSettings,
      userConfiguration: {
        tooltipText: TooltipTextConstants.mdmIOSUserEnrollment,
        kbLink: KbArticleUrls.mdmIOSUserEnrollment,
      },
      shouldRenderGettingStarted: false,
      showLoadingOverlay: true,
    };
  },

  computed: {
    ...mapState(mdmSettingsModel, [
      'item',
    ]),

    ...mapGetters(mdmSettingsModel, [
      'isApnsPushTopicEmpty',
    ]),
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(mdmSettingsModel, [
      'fetchMdmSettings',
    ]),

    handleGettingStartedCta() {
      Util.redirect(ItemTypeRoutes[ItemTypeConsts.mdmSettings]);
    },

    async handleMounted() {
      if (isEmpty(this.item.mdmDevices)) {
        await this.fetchMdmSettings();
      }
      this.showLoadingOverlay = false;
      this.shouldRenderGettingStarted = this.isApnsPushTopicEmpty;
    },
  },
};
</script>
<style module>
@import './CreateSystem.css';
@import '../css/sections.css';

.configContainer {
  padding-top: 2rem;
}

header > .title {
  display: inline-block;
  padding-bottom: 1rem;
}

.tooltipIcon {
  font-size: 14px;
}
</style>
